export default {"src":"/_next/static/media/eugenia.54d9f22f.svg","height":66,"width":351};